const atualizarPeriodicidades = (state, periodicidades) => {
    state.periodicidades = periodicidades;
}

const atualizarPeriodicidade = (state, periodicidade) => {
    state.periodicidade = periodicidade;
}

const atualizarPeriodoPorPlano = (state, periodicidadePlanos) => {
    state.periodicidadePlanos = periodicidadePlanos;
}

const updatePeriodicidade = (state, periodicidade) => {
    const item = state.periodicidades.find(item => item.id === periodicidade.id);

    Object.assign(item, periodicidade);
}

export default {
    atualizarPeriodicidades,
    atualizarPeriodicidade,
    atualizarPeriodoPorPlano,
    updatePeriodicidade
}
